import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from "react-router-dom";

import {navigateOnClick} from "utils/navigateOnClick";
import {OMSRoutes} from "utils/OMSRoutes";
import {greyishBlue100} from "assets/jss/main";

import OrderInfos from "../../../OrderTable/components/OrderRow/components/OrderInfos";
import ZoneAndType from "../../../OrderTable/components/OrderRow/components/ZoneAndType";
import Runner from "../../../OrderTable/components/OrderRow/components/Runner";

import MobileCustomerInfos from "./components/MobileCustomerInfos";
import MobileTotal from "./components/MobileTotal";
import MobileRetailerBadgeList from "./components/MobileRetailerBadgeList";
import MobileLineItemStatusesBadgeList from "./components/MobileLineItemStatusesBadgeList";
import MobileOrderNotes from "./components/MobileOrderNotes";

OrderCard.propTypes = {
    order: PropTypes.object.isRequired
};

function OrderCard({order}) {
    const history = useHistory();

    const {
        id,
        externalId,
        createdAt,
        lineItems,
        customerShippingFirstname,
        customerShippingLastname,
        placedAsGuest,
        customerOrdersCount,
        shipments,
        total,
        retailerTotal,
        adjustments,
        customerCommentCount,
        internalNoteCount,
    } = order;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                padding: '16px',
                borderBottom: `1px solid ${greyishBlue100}`,
                cursor: 'pointer'
            }}
            onClick={(e) => navigateOnClick(e, OMSRoutes.ORDER(id), history)}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <OrderInfos externalId={externalId} date={createdAt} lineItems={lineItems} />
                <MobileOrderNotes customerCommentCount={customerCommentCount} internalNoteCount={internalNoteCount} />

            </div>
            <div>
                <MobileCustomerInfos
                    firstName={customerShippingFirstname}
                    lastName={customerShippingLastname}
                    isGuest={placedAsGuest}
                    totalOrderCount={customerOrdersCount}
                />
                <MobileTotal total={total} retailerTotal={retailerTotal} adjustments={adjustments} lineItems={lineItems} />
            </div>

            <MobileRetailerBadgeList lineItems={lineItems} />
            <MobileLineItemStatusesBadgeList lineItems={lineItems} />

            <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', gap: '8px'}}>
                <ZoneAndType shipments={shipments} />
                <Runner orderId={id} lineItems={lineItems} />
            </div>
        </div>
    );
}

export default OrderCard;
